'use strict';

module.exports = {
    createSkinCss: require('./createSkinCss'),
    renderParam: require('./params').renderParam
};
//# sourceMappingURL=index.js.map